// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".splashPage[data-v-f0b22144]{content:\"\";position:fixed;width:100vw;height:100vh;background-image:url(/static/img/login-bg.jpg);background-position:50%;background-repeat:no-repeat;background-attachment:fixed;background-size:cover}.splashPage .splashInnerPnl[data-v-f0b22144]{text-align:center;width:50%;padding:5%;background:hsla(0,0%,100%,.3);position:absolute}h2[data-v-f0b22144]{font-size:2.3em;font-weight:500}", ""]);
// Exports
module.exports = exports;
